<app-submit-user (submitted)="submitted($event)"></app-submit-user>
